import { cn } from '@duck/ui'
import { LocalizedLink as Link } from '@/components/LocalizedLink'
import { useTar } from '@/modules/i18n/useTar'
import { trackMarketing } from '@/modules/marketingAnalytics'

const GUIDE_CARDS = [
  {
    to: '/analytical-workflow',
    titleKey: 'intentResources.solveAnalyticalTaskTitle',
    descriptionKey: 'intentResources.solveAnalyticalTaskDescription',
  },
  {
    to: '/xp-lab-feedback',
    titleKey: 'intentResources.feedbackTitle',
    descriptionKey: 'intentResources.feedbackDescription',
  },
  {
    to: '/using-ai-without-outsourcing-judgment',
    titleKey: 'intentResources.aiJudgmentTitle',
    descriptionKey: 'intentResources.aiJudgmentDescription',
  },
  {
    to: '/take-home-assignments',
    titleKey: 'intentResources.takeHomeAssignmentsTitle',
    descriptionKey: 'intentResources.takeHomeAssignmentsDescription',
  },
] as const

const GUIDE_NUMERALS = ['I', 'II', 'III', 'IV'] as const

export const HomePageGoDeeper = () => {
  const { t } = useTar()

  return (
    <section className="space-y-7 text-start" aria-labelledby="go-deeper-heading">
      <p id="go-deeper-heading" className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
        {t('home.kickers.goDeeper')}
      </p>
      <ol className="grid grid-cols-1 md:grid-cols-2">
        {GUIDE_CARDS.map((card, index) => {
          const numeral = GUIDE_NUMERALS[index] ?? ''
          const isLeftCol = index % 2 === 0
          return (
            <li
              key={card.to}
              className={cn(
                index < GUIDE_CARDS.length - 1 && 'border-b border-border/60',
                index === GUIDE_CARDS.length - 2 && 'md:border-b-0',
                isLeftCol && 'md:border-e md:border-border/60'
              )}
            >
              <Link
                to={card.to}
                onClick={() =>
                  trackMarketing('home:go_deeper:card_click', {
                    destination: card.to,
                    position: index + 1,
                  })
                }
                className="group relative flex items-start gap-5 px-3 py-6 md:px-7 md:py-7 transition-colors duration-300 hover:bg-accent/[0.06]"
              >
                <span
                  aria-hidden
                  className="font-serif text-4xl font-light leading-none tabular-nums text-accent/40 transition-colors duration-300 group-hover:text-accent/90 mt-0.5 shrink-0 w-10 text-center"
                >
                  {numeral}
                </span>
                <div className="flex-1 min-w-0 space-y-1.5">
                  <h3 className="text-base md:text-lg font-semibold text-foreground leading-snug transition-colors duration-300 group-hover:text-accent">
                    {t(card.titleKey)}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {t(card.descriptionKey)}
                  </p>
                </div>
                <span
                  aria-hidden
                  className="self-center text-base text-muted-foreground/60 transition-all duration-300 group-hover:text-accent group-hover:translate-x-1 rtl:group-hover:-translate-x-1"
                >
                  →
                </span>
              </Link>
            </li>
          )
        })}
      </ol>
    </section>
  )
}
